import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

const HEIGHT = "260px";

export const DeviceDistributionChartContainer = styled.div<{ isFullWidth: boolean }>`
    width: ${(props) => (props.isFullWidth ? "100%" : "calc(50% - 12px)")};
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    background-color: ${colorsPalettes.carbon[0]};
    box-shadow: 0 3px 6px 0 rgb(14 30 62 / 8%);
    border-radius: 6px;
    box-sizing: border-box;
    height: ${HEIGHT};
`;
